// @flow
import React from 'react';
import dataFormat from 'date-fns/format';
import ko from 'date-fns/locale/ko';
import Button from "../../common/Button";
import './CheckoutSuccessTemplate.scss';
import { numberWithCommas } from '../../../lib/common';

type Props = {
  order: any,
};

const CheckoutSuccessTemplate = (props: Props) => (
  <div className="CheckoutSuccessTemplate">
    <div className="checkout-success">
      <h2>성공적으로 주문되었습니다!</h2>

      <div className="checkout-success-message">주문해 주셔서 감사합니다.</div>

      <h3>주문 정보</h3>

      <table className="order-info">
        <tbody>
          <tr>
            <td>주문 번호</td>
            <td>
              <span className="copy-to-id">{props.order.id}</span>
              <span className="copy-to-id-button" onClick={() => {navigator.clipboard.writeText(props.order.id)}}>복사</span>
            </td>
          </tr>
          <tr>
            <td>주문 총액</td>
            <td>{numberWithCommas(props.order.total.amount.raw)}원</td>
          </tr>
          <tr>
            <td>주문 일시</td>
            <td>{dataFormat(props.order.created_at, 'YYYY년 M월 D일 HH시 mm분')}</td>
          </tr>
        </tbody>
      </table>
      <div className="checkout-success-actions">
        <Button className="button view-more-details" to={`/orders/${props.order.id}`}>더 자세히 확인하기</Button>
      </div>
    </div>
  </div>
);

export default CheckoutSuccessTemplate;



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutSuccessTemplate/CheckoutSuccessTemplate.js